import { render } from "./abstractForm.vue?vue&type=template&id=6d16b139"
import script from "./abstractForm.vue?vue&type=script&lang=js"
export * from "./abstractForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__